export function quizDuration(recallQuestionCount, analysisQuestionCount, sentenceStarters) {
	var baseTime = 2;

	baseTime += 2 * recallQuestionCount;

	if (sentenceStarters) {
		baseTime += 3 * analysisQuestionCount;
	} else {
		baseTime += 5 * analysisQuestionCount;
	}

	var higherTime = baseTime + Math.round(baseTime / 3)

	return baseTime + " - " + higherTime;
}



// WEBPACK FOOTER //
// ./modules/lib/academic/QuizCustomization.js